import React from 'react';
import { connect } from 'react-redux';
import { SpaceBetweenWrapper } from '@/controls/components/action-menu/dash-content-action-menu-styles';
import * as userSelectors from '@/user/user-selectors';
import { ControlsPalette } from './controls-palette';

/**
 * This component is meant to render the Action menu in the dashboard content section
 */
function DashContentActionMenuComponent(props) {
  return (
    <SpaceBetweenWrapper>
      {
        props.leftSideChildren || (
          <div />
        ) /* add empty div bc of flex space between */
      }
      <ControlsPalette
        addChartClicked={props.addChartClicked}
        printTrigger={props.printTrigger}
        onDownloadClick={props.onDownloadClick}
        onInformationClick={props.onInformationClick}
      />
    </SpaceBetweenWrapper>
  );
}

function mapStateToProps(state) {
  return {
    currentCity: userSelectors.currentCity(state),
  };
}

export const DashContentActionMenu = connect(mapStateToProps)(
  DashContentActionMenuComponent
);
